// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7gw+f","header":"styles_header__tZ-qs","content":"styles_content__jUWka","full":"styles_full__E6wDW"};